import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

interface LongTermListingsPopupProps {
  open: boolean;
  onClose: () => void;
}

export default function LongTermListingsPopup({ open, onClose }: LongTermListingsPopupProps) {
  const navigate = useNavigate();
  const [hasSeenPopup, setHasSeenPopup] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed this popup in this session
    const dismissed = sessionStorage.getItem('longTermPopupDismissed');
    if (dismissed === 'true') {
      setHasSeenPopup(true);
      onClose();
    }
  }, [onClose]);

  const handleGoToLongTerm = () => {
    navigate('/new-location-tender');
    handleDismiss();
  };

  const handleDismiss = () => {
    // Store dismissal in sessionStorage so it doesn't show again this session
    // (will show again on next login)
    sessionStorage.setItem('longTermPopupDismissed', 'true');
    setHasSeenPopup(true);
    onClose();
  };

  // Don't render if already dismissed
  if (hasSeenPopup) return null;

  return (
    <Dialog open={open && !hasSeenPopup} onOpenChange={(isOpen) => !isOpen && handleDismiss()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-gray-900">
            Long-Term Listings Available
          </DialogTitle>
          <DialogDescription className="text-base text-gray-600 pt-2">
            Submit requests for long-term listings on our network of machines. 
            This includes venue selections, retail media placements, and reporting options.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 pt-4">
          <Button
            onClick={handleGoToLongTerm}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          >
            Go to Long-Term Listings
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            onClick={handleDismiss}
            className="w-full"
          >
            Maybe Later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

